// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closeButton_closeButton__idyGI {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  border-radius: 50%;\n  cursor: pointer;\n}\n.closeButton_closeButton__idyGI::before, .closeButton_closeButton__idyGI::after {\n  position: absolute;\n  content: \"\";\n  background-color: #ffffff;\n  width: 25px;\n  height: 2px;\n}\n.closeButton_closeButton__idyGI::before {\n  top: 20px;\n  right: 10px;\n  transform: rotate(45deg);\n}\n.closeButton_closeButton__idyGI::after {\n  top: 20px;\n  right: 10px;\n  transform: rotate(-45deg);\n}", ""]);
// Exports
exports.locals = {
	"closeButton": "closeButton_closeButton__idyGI"
};
module.exports = exports;
